import { makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AccountPersonalInfo from '../../common/personal-info/account-personal-info.component';
import AccountSettingsSecurity from '../account-settings-security/account-settings-security.jsx';

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    marginBottom: 40,

    "@media (max-width:940px)": {
      marginBottom: 16,
      fontSize: 29,
    },
  },
  personalInfo: {
    marginBottom: 48,
  },
});

const AccountSettings = () => {
  const classes = useStyles();
  const { t } = useTranslation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.container}>
      <span className={`h2 ${classes.title}`}>{t("account.profile")}</span>
      <AccountSettingsSecurity />
      <div className={classes.personalInfo}>
        <AccountPersonalInfo />
      </div>
    </div>
  );
};

export default AccountSettings;
